<template>
  <div class="error-frame">
    <div class="error py-5">
      <p>{{ errorMsg }}</p>
      <button @click="closeMsgModel()" class="mt-5 rounded-lg bg-slate-500 text-white py-1 px-5">關閉</button>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
// import axios from 'axios'

export default {
  name: 'AboutView',
  components: {
    // HelloWorld
  },
  data () {
    return {
      errorMsg: '此為錯誤頁面'
    }
  },
  created () {
    this.errorMsg = this.$route.query.msg || '此為錯誤頁面'
  },
  mounted () {
  },
  computed: {
  },
  methods: {
    closeMsgModel () {
    }
  }
}
</script>
<style lang="scss" scoped>
  .error-frame{
    background: rgba(0,0,0,0.2);
    position: fixed;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    .error{
      background: #ffffff;
      width: 85%;
      height: fit-content;
      max-width: 360px;
      border-radius: 12px;
      box-shadow: 0 0 6px 1px rgba(0,0,0,0.2);
    }
  }
</style>
